import React, { useState, useEffect, useRef } from 'react';
import { CalendarHeader, CalendarLayout } from '@components/calendar';
import { BookingsCalendar } from '@components/calendar';
import TeamCalendar from '@components/calendar/TeamCalendar/TeamCalendar';
import { useAppSelector } from 'hooks/redux';
import { useMediaQuery } from 'react-responsive';
import WaitlistView from '@components/calendar/WaitlistView';
interface IProps {
    next: () => void;
    prev: () => void;
    today: () => void;
    changeView: (view: string) => void;
    showTeamCalenda: boolean;
    teamDate: () => void;
}
const Calendar = () => {
    const _useRef = useRef<IProps>(null);
    var _userData = JSON.parse(localStorage.getItem('user') || '{}');
    const { current_view }: any = useAppSelector(state => state.calenderCurrentView);
    const [view, setView] = useState<any>(
        _userData !== undefined && _userData?.user_login === 'serviceProvider'
            ? 'timeGridDay'
            : current_view
            ? current_view
            : _userData.user.current_view
            ? _userData.user.current_view
            : 'timeGridDay'
    );
    /*
     * Changes when calendar view is changed
     * In ANY calendar view, changes when left/right arrow is clicked
     */
    const [dateRange, setDateRange] = useState('');
    const [showTeamCalendar, setShowTeamCalendar] = useState(false);
    const [showWaitlist, setShowWaitlist] = useState(false);
    const [serviceProviderId, setServiceProviderId] = useState();
    // In ANY calendar view, changes when left/right arrow is clicked
    const [teamCalendarDate, setTeamCalendarDate] = useState<any>();
    const [pickDate, setPickDate] = useState<any>();
    const [calendar_size, setCalendar_Size] = useState<any>();
    const isMobile = useMediaQuery({ query: '(max-width: 760px)' });
    useEffect(() => {
        changeView(
            _userData !== undefined && _userData?.user_login === 'serviceProvider'
                ? 'timeGridDay'
                : current_view
        );
        if (current_view == 'teamGridWeek') {
            setView('timeGridDay');
            setShowTeamCalendar(true);
        }
        if (current_view == 'waitlist') {
            setView('timeGridDay');
            setShowWaitlist(true);
        }
    }, []);

    const next = () => {
        if (_useRef?.current) {
            _useRef?.current?.next();
        }
    };

    const prev = () => {
        if (_useRef?.current) {
            _useRef?.current?.prev();
        }
    };

    const today = () => {
        if (_useRef?.current) {
            _useRef?.current?.today();
        }
    };
    const changeView = (view: string) => {
        if (view === 'teamGridWeek') {
            setShowWaitlist(false);
            setShowTeamCalendar(true);
        } else if (view === 'waitlist') {
            setShowTeamCalendar(false);
            setShowWaitlist(true);
        } else {
            setShowWaitlist(false);
            setShowTeamCalendar(false);
            if (_useRef?.current) {
                _useRef?.current?.changeView(view);
                setView(view);
            }
        }
    };

    return (
        <>
            <CalendarHeader
                setServiceProviderId={setServiceProviderId}
                setCalendar_Size={setCalendar_Size}
                goNext={next}
                goPrev={prev}
                goToday={today}
                currentView={view}
                setPickDate={setPickDate}
                changeView={changeView}
                dateRange={dateRange}
                setDateRange={setDateRange}
                setTeamCalendarDate={setTeamCalendarDate}
                showTeamCalendar={showTeamCalendar}
                teamCalendarDate={teamCalendarDate}
            />
            {showTeamCalendar ? (
                <TeamCalendar
                    numServiceProvidersPerPage={isMobile ? 3 : 7}
                    ref={_useRef}
                    teamCalendarDate={teamCalendarDate}
                    setTeamCalendarDate={setTeamCalendarDate}
                    setDateRange={setDateRange}
                    pickDate={pickDate}
                    calendar_size={calendar_size}
                />
            ) : showWaitlist ? (
                <WaitlistView
                    serviceProviderId={
                        _userData !== undefined && _userData?.user_login === 'serviceProvider'
                            ? _userData.user._id
                            : serviceProviderId
                    }
                    ref={_useRef}
                    setDate={setTeamCalendarDate}
                    date={teamCalendarDate}
                    setDateRange={setDateRange}
                    dateRange={dateRange}
                />
            ) : (
                <BookingsCalendar
                    teamCalendarDate={teamCalendarDate}
                    setTeamCalendarDate={setTeamCalendarDate}
                    ref={_useRef}
                    serviceProviderId={
                        _userData !== undefined && _userData?.user_login === 'serviceProvider'
                            ? _userData.user._id
                            : serviceProviderId
                    }
                    calendar_size={calendar_size}
                    setView={setView}
                    setDateRange={setDateRange}
                    initialView={view}
                    pickDate={pickDate}
                    dateRange={dateRange}
                />
            )}
            <style>{`
            body {
                background-color: #fff;
            }`}</style>
        </>
    );
};

Calendar.Layout = CalendarLayout;
export default Calendar;
